import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTopFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-top-full, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutTopFull"><path d="M3 9V3H21V9H3Z" fill="currentColor"/><path d="M3 10V21H21V10H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutTopFull;
